import { useState } from "react";
import { Bell } from "@/components/ds/icons";
import { Tip } from "@/components/ds/Tip";
import { useNovedadesContext } from "@/hooks/useNovedades";
import { NovedadesModal } from "./NovedadesModal";

/**
 * Campana de Novedades del header. Muestra un punto cuando hay novedades más
 * nuevas que la última marcada como vista, y abre el resumen.
 *
 * El conteo sale del provider de `AppLayout` — el mismo del badge del sidebar y
 * de la pantalla: la campana no fetchea por su cuenta.
 */
export function NovedadesBell() {
  const [open, setOpen] = useState(false);
  const { novedades, loading, error, sinLeer, hasUnseen, marcarVisto } =
    useNovedadesContext();

  const etiqueta = hasUnseen
    ? `Novedades: ${sinLeer} sin leer`
    : "Ver novedades";

  return (
    <>
      <Tip texto={etiqueta}>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg transition-colors hover:bg-accent"
          aria-label={etiqueta}
        >
          <Bell className="h-5 w-5" />
          {hasUnseen && (
            <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-primary" />
          )}
        </button>
      </Tip>

      <NovedadesModal
        open={open}
        onOpenChange={setOpen}
        novedades={novedades}
        loading={loading}
        error={error}
        sinLeer={sinLeer}
        hasUnseen={hasUnseen}
        marcarVisto={marcarVisto}
      />
    </>
  );
}
